import { render, staticRenderFns } from "./editReserveCatalog.vue?vue&type=template&id=5a5d9f3d"
import script from "./editReserveCatalog.vue?vue&type=script&lang=js"
export * from "./editReserveCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports